var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3 "},[_c('div',{staticClass:"card-body py-2 "},[_c('div',{staticClass:"card-title pt-2"},[_vm._v("نمودار بازدید 30 روز گذشته")]),_vm._v(" "),_c('view-chart',{attrs:{"chartData":_vm.chartData}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bdbd7b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/Viewchart.vue
// module id = vEKM
// module chunks = 1